import styled from "styled-components";

import { motion } from 'framer-motion'

export const StarsContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
`;
type StarProps = {
  top: string;
  left: string;
};
export const Star = styled(motion.span) <StarProps>`
  display: inline-block;
  position: absolute;
  width: 2px;
  height: 2px;
  border-radius: 50%;
  background-color: white;
  z-index: 1;
  top: ${(props) => props.top};
  left: ${(props) => props.left};
`;
